<template>
  <div class="contact-us-container">
    <div class="contact-content">
      <div class="title">
        <div class="main contact-enter">
          告诉我们您的需求，<span style="color: #0057ff">改变</span>即刻开始
        </div>
        <div class="sub contact-enter">
          <span>与我们联系，让我们一起创造更好的产品！</span>
        </div>
      </div>
      <div class="contact-btn-container contact-enter">
        <div class="contact-btn" @click="contackUs">
          <span>联系我们</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scrollReveal from "scrollreveal";
export default {
  data() {
    return {
      scrollReveal: scrollReveal(),
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollReveal.reveal(".contact-enter", {
        duration: 200,
        delay: 0,
        interval: 50,
        origin: "bottom",
        viewOffset: {
          bottom: 50,
        },
        reset: false,
        mobile: false,
        distance: "100px",
        opacity: 0,
        easing: "ease",
        scale: 1,
      });
    });
  },
  methods: {
    contackUs() {
      this.$router.push({
        path: "/details",
        query: {
          menuIndex: 4,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-us-container {
  width: 100%;
  padding: 105px 120px 0;
  background: #ffffff;
  .contact-content {
    padding-bottom: 105px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      .main {
        font-family: PingFangSC-Semibold;
        font-size: 40px;
        color: #000000;
        text-align: center;
      }
      .sub {
        margin-top: 16px;
        font-family: PingFangSC-Regular;
        font-size: 20px;
        color: #000000;
        text-align: center;
      }
    }
    .contact-btn-container {
      height: 55px;
      .contact-btn {
        width: 220px;
        height: 50px;
        margin-top: 40px;
        background: #000000;
        border-radius: 25px;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #ffffff;
        line-height: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contactUs.vue